export default __webpack_public_path__ + "static/media/pay.6c065a77.png";